 import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { Table, Spinner } from 'react-bootstrap';
import logo from '../jsx/components/Reports/food.jpeg';
import { useReactToPrint } from "react-to-print";
import { Modal } from 'react-bootstrap';
import React, { Fragment, useState, useEffect, useRef, useImperativeHandle } from "react";
const Invoice = React.forwardRef((props, ref) => {

     const [currentDate, setCurrentDate] = useState(new Date());
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
        const [inviteModal, setInviteModal] = useState(false);
      const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
       useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    //  setOrderItems(props.data1);
    //  setOrder(props.data);
        setRepairOrder(props.data1 || []);
            setMainOrder(props.data || {});
       setTotalAmount(calculateTotal(props.data1));
    },
  }));
  useEffect(() => {
  if (props.data || props.data1) {
    setRepairOrder(props.data1 || []);
    setMainOrder(props.data || {});
    setTotalAmount(calculateTotal(props.data1));
  }
}, [props.data, props.data1]);
  console.log('props.data',props.data)
    const [repairOrder, setRepairOrder] = useState([]);
    const [MainOrder, setMainOrder] = useState({});
    const [loading, setLoading] = useState(true);
    const { repairOrderId } = useParams();
    const [company, setcompany] = useState([]);
    useEffect(() => {
      const companydata = localStorage.getItem('companies');
      if (companydata) {
        const parsedData = JSON.parse(companydata);
        const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
        setcompany(singleCompany); // Set state to a single object
      }
    }, []);
     const calculateTotal = (items) => {
    if (!items) return 0;
    return items.reduce((total, item) => {
      const serviceCost = parseFloat(item.ServiceCost || 0);
      const partCost = parseFloat(item.PartCost || 0);
      const partQuantity = parseFloat(item.PartQuantities || 0);
      console.log(serviceCost)
      console.log(partQuantity)

      console.log(partCost)

      return total + serviceCost + (partCost * partQuantity);
    }, 0);
  };
    const componentRef = useRef(null);
    const generatePDF = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: "Userdata",
       });
     
    
    const { customer, vehicle, TotalCost, RepairDate, Status, RestAmount } = MainOrder;

        const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
    const username = userData.name;
  
    
    return (
            <Modal className="modal fade" id="exampleModal1" size="xl" show={inviteModal} onHide={() => setInviteModal(false)} centered>

        <div className="container-fluid">
        <div className="card-body" ref={componentRef} dir="rtl">

<div className="row mb-4">
   <table className="table table-bordered "style={{ fontSize: "12px", lineHeight: "1" }} size="sm">
       <thead>
      <tr>
        <th colSpan="3" className="text-center bg-light">رقم الفاتورة: {MainOrder.InvoiceNumber}</th>
      </tr>
    </thead>
      
        </table>
        </div>

  {/* Table 1: Vehicle Info */}
  <div className="row mb-4">
  <div className="col-md-6">
     <table className="table table-bordered "style={{ fontSize: "12px", lineHeight: "1" }} size="sm">
       <thead>
      <tr>
        <th colSpan="3" className="text-center bg-light">معلومات السيارة</th>
      </tr>
    </thead>
      <tbody>
         <tr>
          <td><strong>النوع:</strong> {vehicle?.make.MakeName || 'غير متوفر'}</td>
          <td><strong>الموديل:</strong> {vehicle?.vehicle_model.ModelName || 'غير متوفر'}</td>
                    <td><strong>السنة:</strong> {vehicle?.Year || 'غير متوفر'}</td>

        </tr>
        <tr>
          <td><strong>رقم اللوحة:</strong> {vehicle?.LicensePlate || 'غير متوفر'}</td>
        
          <td><strong>اللون:</strong> {vehicle?.Color || 'غير متوفر'}</td>
          <td><strong>رقم الهيكل:</strong> {vehicle?.ChassisNumber || 'غير متوفر'}</td>
        </tr>
        <tr>
          <td><strong>المحرك:</strong> {vehicle?.EngineNumber || 'غير متوفر'}</td>
          <td><strong>العداد:</strong> {MainOrder?.Km || 'غير متوفر'}</td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* Table 2: Customer Info */}
  <div className="col-md-6">
     <table className="table table-bordered table-sm" size="sm"style={{ fontSize: "12px", lineHeight: "1" }} >
      <thead>
      <tr>
        <th colSpan="2" className="text-center bg-light">معلومات الزبون</th>
      </tr>
    </thead>
      <tbody>
        <tr>
          <td><strong>الاسم:</strong> {customer?.FirstName || ''} {customer?.LastName || ''}</td>
          <td><strong>الهاتف:</strong> {customer?.Phone || 'غير متوفر'}</td>
        </tr>
         
      </tbody>
    </table>
  </div>
</div>

{/* Table 3: Parts & Services */}
<div className="row">
  <div className="col-6">
    {/* Services Table */}
{repairOrder.filter(item => item.service).length > 0 && (
  <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
    <thead>
      <tr>
        <th colSpan="3" className="text-center bg-light">الخدمات</th>
      </tr>
      <tr>
        <th>الخدمة</th>
        <th>الفني</th>
        <th>التكلفة</th>
      </tr>
    </thead>
    <tbody>
      {repairOrder.filter(item => item.service).map((item, index) => (
        <tr key={index}>
          <td>{item.service.ServiceName}</td>
          <td>{item.technician?.FirstName || "غير متوفر"}</td>
          <td>{item.ServiceCost || "-"}</td>
        </tr>
      ))}
       <tr>
        <td colSpan="2" className="text-end fw-bold">المجموع</td>
        <td className="fw-bold">
          {repairOrder
            .filter(item => item.service)
            .reduce((sum, item) => sum + (parseFloat(item.ServiceCost) || 0), 0)
          }
        </td>
      </tr>
    </tbody>
  </Table>
)}

{/* Parts Table */}


  </div>
   <div className="col-6">
   {repairOrder.filter(item => item.parts).length > 0 && (
  <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
    <thead>
      <tr>
        <th colSpan="4" className="text-center bg-light">قطع الغيار</th>
      </tr>
      <tr>
        <th>القطعة</th>
        <th>الكمية</th>
        <th>السعر للوحدة</th>
        <th>الإجمالي</th>
      </tr>
    </thead>
    <tbody>
      {repairOrder.filter(item => item.parts).map((item, index) => (
        <tr key={index}>
          <td>{item.parts.PartName}</td>
          <td>{item.PartQuantities || "-"}</td>
          <td>{item.PartCost || "-"}</td>
          <td>{item.PartQuantities && item.PartCost 
                 ? item.PartQuantities * item.PartCost 
                 : "-"}</td>
        </tr>
      ))}
         <tr>
        <td colSpan="3" className="text-end fw-bold">المجموع</td>
        <td className="fw-bold">
          {repairOrder
            .filter(item => item.parts)
            .reduce((sum, item) => sum + ((item.PartQuantities || 0) * (item.PartCost || 0)), 0)
          }
        </td>
      </tr>
    </tbody>
  </Table>
)}
  </div>
</div>
<div className="mt-4">
      <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
           <tbody>
             <tr>
               <td><strong>إجمالي الصيانة:</strong></td>
               <td>
                 {repairOrder.reduce((sum, item) => {
                   const serviceCost = parseFloat(item.ServiceCost) || 0;
                   const partsCost = (parseFloat(item.PartQuantities) || 0) * (parseFloat(item.PartCost) || 0);
                   return sum + serviceCost + partsCost ;
                 }, 0)}
               </td>
             </tr>
             <tr>
               <td><strong>المدفوع مسبقاً:</strong></td>
               <td>{MainOrder?.Prepay || 0}</td>
             </tr>
               <tr>
               <td><strong>سعر الكشف:</strong></td>
               <td>{MainOrder?.CheckPrice || 0}</td>
             </tr>
               <tr>
               <td><strong> النخفيض:</strong></td>
               <td>{MainOrder?.Discount || 0}</td>
             </tr>
             <tr>
              
               <td><strong>المتبقي:</strong></td>
              <td>
  {
    (
      repairOrder.reduce((sum, item) => {
        const serviceCost = parseFloat(item.ServiceCost) || 0;
        const partsCost =
          (parseFloat(item.PartQuantities) || 0) *
          (parseFloat(item.PartCost) || 0);

        return sum + serviceCost + partsCost;
      }, 0)
      + (parseFloat(MainOrder?.CheckPrice) || 0)
      - (parseFloat(MainOrder?.Discount) || 0)
      - (parseFloat(MainOrder?.Prepay) || 0)
    ).toFixed(2)
  }
</td>

             </tr>
             <tr>
               <td colSpan="2"><strong>ملاحظات:</strong>{MainOrder?.Notes} </td>
             </tr>
           </tbody>
         </Table>
  {/* <Table bordered size="sm" style={{ fontSize: "12px", lineHeight: "1" }} >
    <tbody>
      <tr>
        <td><strong>إجمالي الصيانة:</strong></td>
        <td>
          {repairOrder.reduce((sum, item) => {
            const serviceCost = parseFloat(item.ServiceCost) || 0;
            const partsCost = (parseFloat(item.PartQuantities) || 0) * (parseFloat(item.PartCost) || 0);
            return sum + serviceCost + partsCost;
          }, 0)}
        </td>
      </tr>
      <tr>
        <td><strong>المدفوع مسبقاً:</strong></td>
        <td>{MainOrder?.Prepay || 0}</td>
      </tr>
      <tr>
        <td><strong>المتبقي:</strong></td>
        <td>
          {repairOrder.reduce((sum, item) => {
            const serviceCost = parseFloat(item.ServiceCost) || 0;
            const partsCost = (parseFloat(item.PartQuantities) || 0) * (parseFloat(item.PartCost) || 0);
            return sum + serviceCost + partsCost;
          }, 0) - (MainOrder?.Prepay || 0)}
        </td>
      </tr>
      <tr>
        <td colSpan="2"><strong>ملاحظات:</strong> </td>
      </tr>
    </tbody>
  </Table> */}
</div>   </div>
            <div className="row">

              <div className="col-xl-12  ">

<div className=" px-5" style={{float :'right'}}>إعد بواسطة :  {username}</div>  <div className=" px-5" style={{float :'left'}}>    بتاريخ {formatDate(currentDate)}</div><center><p>الختم</p></center>

    </div> </div>   
         <div className="modal-footer">
            <button  className="btn btn-primary m-2" onClick={generatePDF}>طباعه الفاتورة</button>
                        
 
          </div>
        {/* <div className="row">
          <div className="col-lg-12">
            <div className="card mt-3">
            <Link to='/Orderslist' style={{ padding :"30px" ,display: 'flex', alignItems: 'center', position: 'absolute', left: '0px' }}>
  رجوع
  <i className="fa-solid fa-circle-arrow-left  me-3  fa-2xl"></i>
</Link>
        <div className="card-body" ref={componentRef} dir="rtl">
     
            <div className="row mx-3">
                    <div className="col-xl-12 text-center row">
                    <div  style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      }}>  <div 
    style={{
      fontSize: '24px',
      fontWeight: 'bold'
    }}>
                    <div className="d-flex"><h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold'}}>{company.CompanyName}</h2> </div>
                   <div className="d-flex"> <h2 style={{fontFamily: 'SC_AMEEN',color:'#003b53',fontWeight:'lighter'}}>{company.Description}</h2>  </div>
                   <div className="d-flex">                  
                   <h2 style={{fontFamily: 'Cairo',color:'#003b53',fontWeight:'bold' ,fontSize:'14px'}}> تقرير صيانة سيارة</h2>
 </div> </div>

 <img src={`https://subk.education.com.ly/back${company.ImageName}`} alt="Logo" style={{ height: "100px", width: "100px",  marginTop: '-10px',   marginLeft:'30px' }} />                     </div>
                  </div> 
                  </div> 
 
            <table className="table table-bordered">
        <tbody>
           <tr>
          <td><strong >تاريخ اصدار التقرير:</strong> {formatDate(currentDate)}</td>

            <td ><strong>  تاريخ عملية الصيانه: </strong> {RepairDate || 'غير متوفر'}</td>
            <td><strong >  اسم الزبون: </strong> {customer?.FirstName || ''} {customer?.LastName || ''}</td>
            <td><strong>الهاتف  : </strong> {customer?.Phone || ''}</td>

          </tr>

          
          <tr>
          <td><strong> النوع:</strong> {vehicle?.make.MakeName || 'غير متوفر'}</td>
          <td><strong> الموديل  :</strong> {vehicle?.vehicle_model.ModelName || 'غير متوفر'}</td>
          <td><strong>السنه:</strong> {vehicle?.Year || 'غير متوفر'}</td>
            <td><strong>رقم اللوحة:</strong> {vehicle?.LicensePlate || 'غير متوفر'}</td>
          </tr>
          <tr>
            <td><strong>اللون:</strong> {vehicle?.Color || 'غير متوفر'}</td>
            <td><strong>رقم الهيكل:</strong> {vehicle?.ChassisNumber || 'غير متوفر'}</td>
            <td><strong>رقم المحرك:</strong> {vehicle?.EngineNumber || 'غير متوفر'}</td>
            <td><strong>العداد:</strong> {vehicle?.Odometer || 'غير متوفر'}</td>
          </tr>
          <tr>
            <td><strong>نوع الزيت:</strong> {vehicle?.VehicleType || 'غير متوفر'}</td>
            <td><strong>نوع المحرك:</strong> {vehicle?.EngineType || 'غير متوفر'}</td>
            <td><strong>بلد الاستيراد:</strong> {vehicle?.ImportCountry || 'غير متوفر'}</td>
            <td><strong>ملاحظات:</strong> {vehicle?.Notes || 'غير متوفر'}</td>

          </tr>
          
        </tbody>
      </table>

             <div className="col-xl-12">
                <h4>تفاصيل الصيانة</h4>
                {repairOrder.length > 0 ? (
                    <Table bordered>
                         <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                            <tr>
                                <th>الخدمة/القطعة</th>
                                <th>الفني</th>
                               
                            </tr>
                        </thead>
                        <tbody>
                            {repairOrder.map((detail, index) => (
                                <tr key={index}>
                                    <td>  {detail.service?.ServiceName ? `الخدمة : ${detail.service?.ServiceName} ` : detail.parts?.PartName ? `القطعة : ${detail.parts?.PartName} `: 'غير متوفر'}</td>
                                    <td>{detail.technician?.FirstName	 || 'غير متوفر'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <p>لا توجد تفاصيل صيانة متوفرة.</p>
                )}
            </div>

        
          
            </div> </div> </div> 
            <div className="modal-footer">
              <button className="btn btn-success" onClick={generatePDF}>طباعه</button>
          </div></div>  */}</div></Modal>
    );
});

export default Invoice;
